'use strict'

module.exports = function (node) {
  return 'scope["' + node.name + '"] = ' + this.next(node.expr)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-codegen/lib/node/AssignmentNode.js
// module id = 8/qj
// module chunks = 0